import { render, staticRenderFns } from "./CustomerStatements.vue?vue&type=template&id=ba7a1fe0&scoped=true&"
import script from "./CustomerStatements.vue?vue&type=script&lang=js&"
export * from "./CustomerStatements.vue?vue&type=script&lang=js&"
import style0 from "./CustomerStatements.vue?vue&type=style&index=0&id=ba7a1fe0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7a1fe0",
  null
  
)

export default component.exports